import { Component, ElementRef, Input, type OnDestroy, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import type { BasketInvoice } from '../transactions-layout/models/transaction';
import { ReceiptDetail } from '../print-receipt/print-receipt.component';

export class InvoiceOptions {
  constructor(
    public vatRegNo: string,
    public invoiceNumber: string,
    public businessName: string,
    public businessAddress: string,
    public billedTo: string,
    public notes: string,
  ) {}
}

export class InvoiceDetail {
  constructor(
    public receipt: ReceiptDetail,
    public options: InvoiceOptions,
  ) {}
}

@Component({
  standalone: false,
  selector: 'odin-print-invoice',
  templateUrl: './print-invoice.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./print-invoice.component.css'],
})
export class PrintInvoiceComponent implements OnDestroy {
  @Input() public invoiceDetail?: InvoiceDetail = undefined;

  public today: Date = new Date();

  private printEl: HTMLElement | null = null;

  // Reparent the print template to <body> — same iOS Safari fix as
  // PrintReceiptComponent (fixed/nested print content renders at viewport
  // width in the top-left of the printed page).
  @ViewChild('printTemplate')
  set printTemplate(el: ElementRef<HTMLElement> | undefined) {
    this.printEl = el?.nativeElement ?? null;
    if (this.printEl && this.printEl.parentElement !== document.body) {
      document.body.appendChild(this.printEl);
    }
  }

  ngOnDestroy(): void {
    this.printEl?.remove();
  }

  public get basketInvoice(): BasketInvoice | undefined {
    return this.invoiceDetail?.receipt.basket?.invoice;
  }
}
